import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Home, Utensils, Dumbbell, TrendingUp, MessageSquare, LogOut, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function TopBar({ showAuth = true }) {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-40 bg-[#0A0A0A]/95 backdrop-blur border-b border-[#1f1f1f]">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <div className="w-8 h-8 bg-gold text-black grid place-items-center font-display font-black text-lg">K</div>
          <div className="font-display font-black uppercase tracking-tight text-lg leading-none">
            Kaihau <span className="text-gold">Warrior</span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm uppercase tracking-widest text-neutral-300">
          <Link to="/" data-testid="nav-home">Home</Link>
          <Link to="/program" data-testid="nav-program">Programme</Link>
          <Link to="/pricing" data-testid="nav-pricing">Pricing</Link>
          <Link to="/apply" data-testid="nav-apply">Apply</Link>
          <Link to="/privacy" data-testid="nav-privacy">Privacy</Link>
        </nav>
        {showAuth && (
          <div className="flex items-center gap-2">
            {user && user.id ? (
              <>
                <Link to={user.role === "coach" ? "/coach" : "/app/dashboard"} className="kw-btn-outline text-xs" data-testid="nav-dashboard">Dashboard</Link>
                <button onClick={logout} className="kw-btn-outline text-xs" data-testid="nav-logout"><LogOut className="w-4 h-4"/></button>
              </>
            ) : (
              <>
                <Link to="/login" className="kw-btn-outline text-xs" data-testid="nav-login">Login</Link>
                <Link to="/apply" className="kw-btn-primary text-xs" data-testid="nav-apply-cta">Apply</Link>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
}

export function BottomNav() {
  const items = [
    { to: "/app/dashboard", icon: Home, label: "Home", testid: "bn-home" },
    { to: "/app/nutrition", icon: Utensils, label: "Food", testid: "bn-food" },
    { to: "/app/workouts", icon: Dumbbell, label: "Train", testid: "bn-train" },
    { to: "/app/progress", icon: TrendingUp, label: "Progress", testid: "bn-progress" },
    { to: "/app/messages", icon: MessageSquare, label: "Coach", testid: "bn-coach" },
  ];
  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-[#0A0A0A] border-t border-[#1f1f1f]" style={{paddingBottom: "env(safe-area-inset-bottom, 0px)"}} data-testid="bottom-nav">
      <div className="max-w-xl mx-auto grid grid-cols-5">
        {items.map(({ to, icon: Icon, label, testid }) => (
          <NavLink key={to} to={to} data-testid={testid} className={({ isActive }) => `flex flex-col items-center justify-center py-2.5 text-[11px] uppercase tracking-widest ${isActive ? "text-gold" : "text-neutral-400"}`}>
            <Icon className="w-5 h-5 mb-1" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export function CoachTopBar() {
  const { logout, user } = useAuth();
  return (
    <header className="sticky top-0 z-40 bg-[#0A0A0A] border-b border-[#1f1f1f]">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/coach" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-gold text-black grid place-items-center font-display font-black text-lg">K</div>
          <div className="font-display font-black uppercase tracking-tight text-lg">Coach Console</div>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm uppercase tracking-widest">
          <NavLink to="/coach" end className={({isActive}) => isActive ? "text-gold" : "text-neutral-300"} data-testid="coach-nav-clients">Clients</NavLink>
          <NavLink to="/coach/applications" className={({isActive}) => isActive ? "text-gold" : "text-neutral-300"} data-testid="coach-nav-apps">Applications</NavLink>
          <NavLink to="/coach/messages" className={({isActive}) => isActive ? "text-gold" : "text-neutral-300"} data-testid="coach-nav-messages">Messages</NavLink>
        </nav>
        <div className="flex items-center gap-2">
          <div className="hidden sm:flex items-center gap-2 text-xs text-neutral-400"><User className="w-4 h-4"/>{user?.name}</div>
          <button onClick={logout} className="kw-btn-outline text-xs" data-testid="coach-logout"><LogOut className="w-4 h-4"/></button>
        </div>
      </div>
    </header>
  );
}
